function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
}

export function RgbToHex(r, g, b, prefix = '#') {
    return prefix + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

export function HexToRgb(hex) {
    const hexString = hex.replace('0x', '#');
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexString);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

export function GetCssRgba(rgbaColor) {
    return 'rgba(' + rgbaColor.r + ',' + rgbaColor.g + ',' + rgbaColor.b + ',' + (rgbaColor.a ? rgbaColor.a : 1) + ')';
}